export default __webpack_public_path__ + "static/media/user-16.e08baef6.jpg";